jQuery(function ($) {
    // Carousel Posts/Custom
    if ($('.carousel-block:not(.carousel-type-columns):not(.tutorial-carousel):not(.resources-carousel)')) {
        $('.carousel-block:not(.carousel-type-columns):not(.tutorial-carousel):not(.resources-carousel)').each(function () {
            if ($(this).find('.carousel-slide').length > 1) {
                let slider = $(this).find('.ems-slick-container:not(.carousel-type-columns)');
                let arrow_next = $(this).find('.carousel-arrows .slick-next');
                let arrow_prev = $(this).find('.carousel-arrows .slick-prev');
                //console.log('first', slider);
                slider.slick({
                    fade: true,
                    dots: false,
                    arrows: true,
                    autoplay: false,
                    speed: 650,
                    prevArrow: arrow_prev,
                    nextArrow: arrow_next,
                    variableHeight: false,

                });

                $(slider).removeClass('uninitialized');

                $(window).on('resize', function () {
                    //console.log(slider);
                    slider.slick('resize');
                });
            } else {
                $(this).find('.ems-slick-container').removeClass('uninitialized');
            }

        });


    }


    if ($('.wp-block-gallery.badges')) {
        $('.wp-block-gallery.badges').each(function () {
            $large_to_show = $(this).find('img').length - 1 > 9 ? 9 : $(this).find('img').length - 1;
            $medium_to_show = $(this).find('img').length - 1 > 6 ? 6 : $(this).find('img').length - 1;
            $small_to_show = $(this).find('img').length - 1 > 3 ? 3 : $(this).find('img').length - 1;
            $extra_small_to_show = $(this).find('img').length - 1 > 2 ? 2 : $(this).find('img').length - 1;
            $(this).slick({
                dots: false,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: 'linear',
                slidesToShow: $(this).find('img').length - 1,
                centerMode: true,
                slidesToScroll: 1,
                variableHeight: false,
                infinte: true,
                loop: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                pauseOnDotsHover: false,
                swipe: false,
                touchMove: false,
                draggable: false,
                swipeToSlide: false,
                responsive: [
                    {
                        breakpoint: 1480,
                        settings: {
                            slidesToShow: $large_to_show
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $medium_to_show
                        }
                    },
                    {
                        breakpoint: 780,
                        settings: {
                            slidesToShow: $small_to_show
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: $extra_small_to_show
                        }
                    }
                ]
            })
        });
    }

    if ($('.wp-block-gallery.top-clients')) {
        $('.wp-block-gallery.top-clients').each(function () {
            slider = $(this);
            if ($(slider).find('img').length > 3) {
                $medium_to_show = $(slider).find('img').length - 1 > 7 ? 7 : $(slider).find('img').length - 1;
                $small_to_show = $(slider).find('img').length - 1 > 3 ? 3 : $(slider).find('img').length - 1;
                $(slider).find('.wp-block-image').each(function () {
                    $(this).clone().appendTo(slider);
                });
                $(slider).find('.wp-block-image').each(function () {
                    $(this).clone().appendTo(slider);
                });
                $(slider).slick({
                    dots: false,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 0,
                    speed: 5000,
                    cssEase: 'linear',
                    slidesToShow: $(this).find('img').length - 1,
                    centerMode: true,
                    slidesToScroll: 1,
                    variableHeight: false,
                    infinte: true,
                    loop: true,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    pauseOnDotsHover: false,
                    swipe: false,
                    touchMove: false,
                    draggable: false,
                    swipeToSlide: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: $medium_to_show
                            }
                        },
                        {
                            breakpoint: 780,
                            settings: {
                                slidesToShow: $small_to_show
                            }
                        },
                    ]
                })
            }
        });
    }

    if ($('.block.tutorial-carousel')) {
        $('.block.tutorial-carousel').each(function () {
            // console.log($(this));
            let slider = $(this).find('.carousel-type-tutorial');
            // console.log('tutorial slider', $(slider).find('.teaser').length, $(slider).hasClass('disabled-carousel'));
            if(!$(slider).hasClass('disabled-carousel')){
                console.log('okok', $(slider).find('.teaser').length > 2);
                if ($(slider).find('.teaser').length > 2) {
                    console.log('init', slider);
                    let arrow_next = $(this).find('.carousel-arrows .slick-next');
                    let arrow_prev = $(this).find('.carousel-arrows .slick-prev');
                    slider.slick({
                        fade: false,
                        dots: false,
                        arrows: true,
                        autoplay: false,
                        // speed: 650,
                        slidesToShow: 2,
                        prevArrow: arrow_prev,
                        nextArrow: arrow_next,
                        variableHeight: false,
                        loop: true,
                    
                        responsive: [
                            {
                                breakpoint: 940,
                                settings: {
                                    slidesToShow: 1
                                }
                            },]
                    });
                } else {
                    $(this).find('.carousel-arrows').hide();
                }
            }
            $(this).find('.uninitialized').removeClass('uninitialized');
        });
    }

    if ($('.block.resources-carousel')) {
        $('.block.resources-carousel').each(function () {
            // console.log($(this));
            let slider = $(this).find('.carousel-type-resources');
            // console.log('tutorial slider', $(slider).find('.teaser').length, $(slider).hasClass('disabled-carousel'));
            if(!$(slider).hasClass('disabled-carousel')){
                console.log('okokok', $(slider).find('.teaser').length > 2);
                if ($(slider).find('.teaser').length > 2) {
                    console.log('init', slider);
                    let arrow_next = $(this).find('.carousel-arrows .slick-next');
                    let arrow_prev = $(this).find('.carousel-arrows .slick-prev');
                    slider.slick({
                        fade: false,
                        dots: false,
                        arrows: true,
                        autoplay: false,
                        // speed: 650,
                        slidesToShow: 3,
                        prevArrow: arrow_prev,
                        nextArrow: arrow_next,
                        variableHeight: false,
                        loop: true,
                    
                        responsive: [
                            {
                                breakpoint: 940,
                                settings: {
                                    slidesToShow: 1
                                }
                            },]
                    });
                } else {
                    $(this).find('.carousel-arrows').hide();
                }
            }
            $(this).find('.uninitialized').removeClass('uninitialized');
        });
    }
    // if ($('.timeline__slider')) {
    //     $('.timeline__slider').slick({
    //         'slide': '.timeline__slider__slide',
    //         'vertical': true,
    //         'slidesToShow': 2,
    //         'slidesToScroll': 1,
    //         'infinite': false,
    //         'loop': false,
    //         'swipeToSlide': true,
    //         'verticalSwiping': true,
    //         'adaptiveHeight': true,
    //         'dots': true,
    //         'appendDots': $('.timeline__slider__nav__dots'),
    //         'prevArrow': $('.timeline__slider__nav__prev'),
    //         'nextArrow': $('.timeline__slider__nav__next'),
    //     })
    // }
})